module.exports = __webpack_public_path__ + "media/images/new-ui-images/notification-icon-b7028825708c5ac07a563a04db83ff5b.svg";